import * as React from "react"
import { connect } from "react-redux"
import trans from "trans"
import Mergado from "app/helpers/mergado"

import {
    Grid,
    GridCell,
    DataRow,
    DataCell,
    Theme,
    PopupHint,
    Icon,
    css,
    Button,
} from "@bdfx/mergado-ui-kit"

import {URL} from "app/config/api-config";
import {
    eshopId,
    isGodModeOn,
    MERGADO_APP,
    projectId,
    publishProductToWatermarkDetector
} from "app/helpers/api";

import { createProductsExport } from "app/reducers/exports"

import {FiltersFormType} from "../types/filtertypes";
import {renderItemId, renderName} from "./product-table";
import _map from "lodash/map";
import {DarkGrayColor} from "app/helpers/colors";
import {invertColor} from "app/helpers/other";
import {
    allowObjectToImageRatioForUsers,
} from "template-edit/components/helper";
import {RouterType, withRouter} from "app/components/routes";
import {ExtendedProductType} from "../types";
import {ID} from "app/types/app-types";
import {AxiosResponse} from "axios";
import store from "store";
import {createToast} from "actions";
import {textToast} from "app/helpers/toast_factory";
import { TemplateBadges } from "template-list/template-badges"
import FindSimilarButton from "./find-similar-button"

interface Props {
    router: RouterType
    product: ExtendedProductType
    groupNames: string
    copyToClipboard: Function
    copiedToClipboard: number | string | null  //ID of element which was copied into clipboard
    createProductsExport: typeof createProductsExport
    showModal: Function
    getEmptyFiltersForm: Function
    idx: number
    showAlternativeImages: boolean
    userId: number
}


class ProductTableRow extends React.Component<Props> {
    constructor(props: Props) {
        super(props)
    }

    exportRowToCSV = (mergado_id : [{id: number}]) => {
        const mergadoids : number[] = mergado_id ? Object.keys(mergado_id).map(k => mergado_id[k].id) : []
        const filters : FiltersFormType = {
            ...this.props.getEmptyFiltersForm(),
            mergadoids: mergadoids,
        }

        this.props.createProductsExport(filters, 'row')
    }

    getStatusIcon = (statusCode, errorCode) => {
        switch (statusCode+'_'+errorCode) {
            case '200_null':
            case '200_0':
                return <Icon type={'check'} color={Theme.green} size={16} text={statusCode} />
            case '200_1':
                return <Icon type={'square-o'} size={16} color={DarkGrayColor} text={statusCode} />
            case '200_420':
                return <Icon type={'question'} size={16} color={Theme.orange} text={statusCode} />
            case '200_435':
                return <Icon type={'exclamation'} size={16} color={Theme.blue} text={statusCode} />
            case '200_465':
                return <Icon type={'arrows-h'} size={16} color={Theme.red} text={statusCode} />
            case '500_0':
            case '500_null':
                return <Icon type={'exclamation-circle'} size={16} color={Theme.red} text={statusCode} />
            default:
                return <Icon type={'info-circle'} color={Theme.blue} size={16} text={statusCode} />
        }
    }

    handleSendToWatermarkDetector = (watermarkGroupId: ID, productId: ID) => {
        publishProductToWatermarkDetector(watermarkGroupId, productId)
            .then((response: AxiosResponse<any>) => {
                store.dispatch(createToast(textToast('success', trans('published'))))
            })
            .catch(e => {
                store.dispatch(createToast(textToast('error', `cannot publish image to watermark detector: ${e.response?.data?.message}`)))
                console.error('cannot publish product', e.response)
            })
    }

    render() {
        const {groupNames, product, copiedToClipboard, idx} = this.props
        /* const timeStamp = new Date(product.rendered_at).getTime() */

        const timeStamp = new Date().getTime()
        const mergado_id = product.mergado_id ? JSON.parse(product.mergado_id) : null
        const mergadoProductUrl = `${MERGADO_APP}/${product.product_id}`
        const previewUrl = `${URL.laravelBase}images?template_id=${product.template_id}&product_id=${product.product_id}&nocache=0`
        const upscaledUrl = `${URL.laravelBase}get-upscaled-image/${product.project_id}/${product.image_hash}?ts=${timeStamp}`
        const bgremovedUrl = `${URL.laravelBase}get-bgremoved-image/${product.project_id}/${product.image_hash}/${product.template_effect_sensitivity}?t=${timeStamp}`
        const wmremovedUrl = `${URL.laravelBase}get-wmremoved/${product.project_id}/${product.image_url_hash}?t=${timeStamp}`
        const sourceimageUrl = `${URL.laravelBase}get-source-image/${product.project_id}/${product.image_hash}?t=${timeStamp}`

        const mergadoIdQuery = mergado_id ? '@MERGADO_ID IN(' + _map(mergado_id, 'id').join(';') + ')' : null

        const emptyImages = groupNames.includes('empty_images')
        const sameImages = groupNames.includes('same_images')
        const invalidUrl = groupNames.includes('invalid_url')

        const iconSize = 24

        return (
            <DataRow dataId={`product-${product.product_id}`}>
                {!emptyImages &&
                <DataCell key={'status_code'} className='centered'>
                    {product.image_status_code > 0 &&
                        <div title={`${product.error || ''}`}>
                        <PopupHint
                            icon={this.getStatusIcon(product.image_status_code, product.image_error_code)}>
                            {trans('status_' + product.image_status_code + '_' + product.image_error_code)}
                        </PopupHint>
                        </div>
                    }
                </DataCell>
                }

                {!emptyImages &&
                <>
                    <DataCell key={'product_image'} className='clickable centered' onClick={() => this.props.showModal(idx)}>
                        {product.image_link !== '' ? <img src={product.image_link} height={50}/> : trans('no_image')}
                    </DataCell>

                    {this.props.showAlternativeImages &&
                    <DataCell key={'alternative_images'} className='clickable centered'>
                        {product.alternative_images &&
                        <Grid cols="repeat(3, 1fr)">
                            {product.alternative_images.map(a => {
                                return <GridCell key={'alt' + a.id}>
                                    <img src={a.url} width="40" onClick={() => this.props.showModal(idx, a.level)} />
                                </GridCell>
                            })}
                        </Grid>
                        }
                    </DataCell>
                    }

                    <DataCell style={{textAlign: 'center'}}>
                        {product.image_bg_color !== null &&
                        <div className={product.image_is_transparent ? 'checker' : ''} style={{marginBottom: '10px'}}>
                            <span style={{
                                width: '80px',
                                height: '80px',
                                background: product.image_bg_color,
                                color: product.image_bg_color ? invertColor(product.image_bg_color) : '#000',
                                border: '1px solid gray',
                                lineHeight: '80px',
                                verticalAlign: 'middle',
                                padding: '30px 10px',
                            }}>{product.image_bg_color}</span>
                        </div>
                        }

                        {product.image_is_transparent === 1 &&
                        <div>{trans('transparent_bg')}</div>
                        }

                        {product.image_is_solid_bg === 1 &&
                        <div>{trans('solid_bg')}</div>
                        }
                    </DataCell>
                </>
                }

                {invalidUrl &&
                <DataCell key={'product_image_link'}>
                    {product.image_link ? product.image_link : trans('no_image')}
                </DataCell>
                }

                {!emptyImages && (allowObjectToImageRatioForUsers.includes(this.props.userId) || isGodModeOn) &&
                <DataCell className={'some-users-only'} key={'object_to_image_ratio'} style={{textAlign: 'center'}}>
                    {product.image_object_to_image_ratio ? `${product.image_object_to_image_ratio}%` : ''}
                </DataCell>
                }

                <DataCell key={'product_name'} className='clickable incognito' onClick={() => Mergado.openWindow(product.elements_url)}>
                    {renderName(product.elements_name)}
                    <br/>
                    {renderItemId(product.elements_item_id)}
                </DataCell>

                <DataCell key={'price_vat'} className={'right'}>{product.elements_price_vat ? product.elements_price_vat : ''}</DataCell>
                <DataCell key={'category_text'}>{product.elements_categorytext ? product.elements_categorytext : ''}</DataCell>
                <DataCell key={'manufacturer'}>{product.elements_manufacturer ? product.elements_manufacturer : ''}</DataCell>

                <DataCell key={'template'}>
                    {product.template && product.template.name &&
                    <div className={'nowrap clickable'} onClick={() => this.props.router.navigate(`/eshop/${eshopId}/project/${projectId}/templates/${product.template_id}/edit`)} title={`${trans('edit')} ${product.template_id}`}>
                        {product.template.name}
                    </div>
                    }

                    {product.template && product.template.size && product.template.size.width && product.template.size.height &&
                    <div className={'nowrap'}>
                        [{product.template.size.width} × {product.template.size.height}]
                    </div>
                    }

                    {product.template &&
                        <TemplateBadges template={product.template} showIcons={true}  showInline={false} />
                    }
                </DataCell>

                {sameImages && mergado_id &&
                <>
                    <DataCell key={'same_images_list'}>
                        <ul className={'product-list'}>
                            {mergado_id.map(l => {
                                const productLink = `${MERGADO_APP}/${l.id}`
                                return <li
                                    key={`item_${product.product_id}_${l.id}`}
                                    className='clickable mergado-list'
                                    onClick={() => Mergado.openWindow(productLink)}
                                >
                                    {l.id}
                                </li>
                            })}
                            <li className={`copy-to-clipboard`}>
                                <Icon type={'mergado'} size={20} />
                                <div id={'mergado_query__' + product.product_id} className={'id-list'}>
                                    {mergadoIdQuery}
                                </div>
                            </li>

                            {product.mergado_query &&
                                <li
                                    key={`copy_to_clipboard ${product.product_id}`}
                                    onClick={(e) => this.props.copyToClipboard(e, product.product_id)}
                                    className={`copy-to-clipboard ${copiedToClipboard === product.product_id ? 'copied' : ''}`}
                                    title={trans('copy_mergado_query')}>
                                    <Icon type={'clipboard'} size={20} color={copiedToClipboard === product.product_id ? DarkGrayColor : Theme.blue} />
                                    <div id={'mergado_query_' + product.product_id} className={'id-list'}>
                                        {copiedToClipboard === product.product_id &&
                                            <span style={{ paddingRight: '5px' }}>({trans('copied_to_clipboard')})</span>
                                        }
                                        {product.mergado_query}
                                    </div>
                                </li>
                            }
                        </ul>

                    </DataCell>
                    <DataCell key={'total'} className='centered clickable'>{product.total}</DataCell>
                </>
                }

                {!emptyImages && !invalidUrl && !sameImages &&
                <>
                    <DataCell key={'width'} className='centered'>{product.image_width && product.image_width}</DataCell>
                    <DataCell key={'image_height'} className='centered'>{product.image_height && product.image_height}</DataCell>
                    <DataCell key={'content_type'} className='centered'>{product.image_content_type && product.image_content_type}</DataCell>
                    <DataCell key={'content_length'} className='centered'>{product.image_content_length && (product.image_content_length / 1024).toFixed(2)}</DataCell>
                    <DataCell key={'rendered_size'} className='centered'>{product.rendered_size && (product.rendered_size / 1024).toFixed(2)}</DataCell>
                    <DataCell key={'rendered_compression'} className='centered'>{product.rendered_compression && product.rendered_compression}</DataCell>
                    {/* <DataCell key={'rendered_sensitivity'} className='centered'>{product.rendered_sensitivity && trans(product.rendered_sensitivity)}</DataCell> */}
                    <DataCell key={'color_space_string'} className='centered'>{product.image_color_space_string && product.image_color_space_string}</DataCell>
                </>
                }

                <DataCell key={'links'} className='centered clickable'>
                    <Grid cols={`repeat(${(emptyImages || sameImages) ? 6 : 5}, 1fr)`} className={'product-links'}>
                        {product.image_link &&
                        <GridCell className='clickable'>
                            <div onClick={() => Mergado.openWindow(product.image_link)} title={trans("link_image_url")}>
                            <Icon type={'file-image-o'} color={Theme.blue} size={20} />
                            </div>
                        </GridCell>
                        }
                        {previewUrl &&
                        <GridCell className='clickable'>
                            <div onClick={() => Mergado.openWindow(previewUrl)} title={trans("link_fie")}>
                            <Icon type={'feedimageeditor'} size={20}/>
                            </div>
                        </GridCell>
                        }
                        {mergadoProductUrl &&
                        <GridCell className='clickable'>
                            <div onClick={() => Mergado.openWindow(mergadoProductUrl)} title={trans("link_mergado")} >
                            <Icon type={'mergado'} size={20} />
                            </div>
                        </GridCell>
                        }
                        {product.elements_url &&
                        <GridCell className='clickable'>
                            <div onClick={() => Mergado.openWindow(product.elements_url)} title={trans("link_eshop")}>
                            <Icon type={'shopping-basket'} color={DarkGrayColor} size={20}/>
                            </div>
                        </GridCell>
                        }
                        {product.elements_ean &&
                        <GridCell className='clickable'>
                            <div onClick={() => Mergado.openWindow(`https://www.barcodelookup.com/${product.elements_ean}`)} title={trans("barcode_lookup")} >
                                <Icon type={'barcode'} color={DarkGrayColor} size={20} />
                            </div>
                        </GridCell>
                        }
                        <GridCell>
                            <FindSimilarButton imageHash={product.image_hash} />
                        </GridCell>
                        {/*{product.ean &&
                        <GridCell className='clickable'>
                            <div onClick={() => Mergado.openWindow(`http://product-open-data.com/search/${product.ean}`)}>
                                <Icon type={'barcode'} color={DarkGrayColor} title={trans("product_open_data")} size={20} />
                            </div>
                        </GridCell>
                        }*/}
                        {(emptyImages || sameImages) &&
                        <GridCell className='clickable'>
                            <div onClick={() => this.exportRowToCSV(mergado_id)}>
                            <Icon type={'file-csv'} color={DarkGrayColor} title={trans("export_to_csv")} size={20} />
                            </div>
                        </GridCell>
                        }
                    </Grid>
                </DataCell>
            </DataRow>
        )
    }
}

function mapStateToProps(state) {
    return {}
}

export default connect(mapStateToProps, {
    createProductsExport,
})(withRouter(ProductTableRow))
